import React from "react";
// import Header from "../../../Components/Header";
// import Sidebar from "../../../Components/Sidebar";
function GetCompliance() {
    return (
        <>
            <div className="col-md-9 col-lg-9 col-xxl-10">
                <div className="row ms-lg-4 ms-xl-5 m-0">
                    {/* <div className="col-md-3 col-lg-3 col-xxl-2 p-0">
                      <Sidebar />
                  </div> */}
                    <div className="col-12">
                        <div className="main-heading">
                            <h3> Compliance</h3>
                            <h6>Get Money Transfer Limits</h6>
                            <p>
                                This function lists the registered money transfer limits.
                            </p>
                        </div>
                        <div className="row">
                            <div className="col-xxl-8">
                                <div className="wallet-balances-box m-0">
                                    <div className="d-md-flex justify-content-end px-4">
                                        <button type="button" className="btn btn-primary ">+ ADD Limit Rule</button>
                                    </div>
                                    <div className="table-responsive p-3 p-md-4">
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Time Period</th>
                                                    <th>Period Type</th>
                                                    <th>Limit Amount</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1 Day</td>
                                                    <td>Fiscal</td>
                                                    <td>$1,000</td>
                                                    <td>Active</td>
                                                </tr>
                                                <tr>
                                                    <td>1 Day</td>
                                                    <td>Fiscal</td>
                                                    <td>$1,000</td>
                                                    <td>Active</td>
                                                </tr>
                                                <tr>
                                                    <td>1 Day</td>
                                                    <td>Fiscal</td>
                                                    <td>$1,000</td>
                                                    <td>Active</td>
                                                </tr>
                                                <tr>
                                                    <td>1 Day</td>
                                                    <td>Fiscal</td>
                                                    <td>$1,000</td>
                                                    <td>Active</td>
                                                </tr>
                                                <tr>
                                                    <td>1 Day</td>
                                                    <td>Fiscal</td>
                                                    <td>$1,000</td>
                                                    <td>Active</td>
                                                </tr>
                                                <tr>
                                                    <td>1 Day</td>
                                                    <td>Fiscal</td>
                                                    <td>$1,000</td>
                                                    <td>Active</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </>
    );
}

export default GetCompliance;
